import React from 'react';
import PropTypes from 'prop-types';
import { FlattenedNode } from '../shapes';

export const BasicNode = node => (
  <span className="tree-view-basic-node">{node.name}</span>
);

BasicNode.propTypes = PropTypes.shape(FlattenedNode);

